import { Text } from '@modusign/design-system';
import { SigningMethod } from '@modusign/react-signing/types';

interface RequestLocaleInfoProps {
  locale: string;
  signingMethod: SigningMethod | null;
}

const formattedLocales: Record<string, string> = {
  ko: '한국어',
  en: '영어',
  'zh-CN': '중국어',
  ja: '일본어',
  vi: '베트남어',
};

export default function SigningMethodTypeInfo({ locale, signingMethod }: RequestLocaleInfoProps) {
  switch (signingMethod) {
    case 'EMAIL':
    case 'KAKAO':
      return (
        <Text as="div" color="textNeutralLight" fontSize="sm" mt={1}>
          {formattedLocales[locale]}로 서명 요청됩니다.
        </Text>
      );
    case 'SECURE_LINK':
      return (
        <Text as="div" color="textNeutralLight" fontSize="sm" mt={1}>
          보안링크로 참여합니다.
        </Text>
      );
    case 'IN_PERSON':
    default:
      return null;
  }
}
